export default "__VITE_ASSET__Da7V45BX__"